export default __webpack_public_path__ + "static/media/download_enable.fc8930d9.svg";